import Frame from "../components/Frame";
import { EarIcon } from "../components/Icons";
import ResetTablet from "../components/ResetTablet";
import RetryPanel from "../components/RetryPanel";
import ui from "../components/ui.module.css";
import { dueLabel, purposeLabel } from "../data/workLabels";

// Quiet before release: attention belongs to the teacher. Work the teacher set
// for later (homework, practice, a test) is listed underneath, quietly, with
// My Learning beside it (Handoff 007 §10). A live release always comes first:
// it replaces this screen as soon as it appears. The adult's reset sits small
// at the foot of the screen.
const Waiting = ({ assignments, saving, retry, onOpen, onMyLearning, onReset }) => {
  const open = Array.isArray(assignments) ? assignments : [];
  return (
    <Frame centered>
      <span className={`${ui.bigIcon} ${ui.breathe}`}>
        <EarIcon size={72} />
      </span>
      <h1 className={ui.learnerTitle}>Listen to your teacher</h1>

      {open.length > 0 && (
        <section aria-labelledby="work-title" className={ui.workList}>
          <h2 id="work-title" className={ui.sectionTitle}>
            Your work
          </h2>
          <ul className={ui.workList}>
            {open.map((item) => {
              const due = dueLabel(item.dueAt);
              return (
                <li key={item.id}>
                  <button
                    type="button"
                    className={ui.workItem}
                    onClick={() => onOpen(item.id)}
                    disabled={saving}
                  >
                    <span>
                      <span className={ui.workItemTitle}>{item.title || purposeLabel(item.purpose)}</span>
                      <br />
                      <span className={ui.meta}>{purposeLabel(item.purpose)}</span>
                    </span>
                    {due && <span className={`${ui.workBadge} ${ui.workBadgeDue}`}>{due}</span>}
                  </button>
                </li>
              );
            })}
          </ul>
        </section>
      )}

      {onMyLearning && (
        <button
          type="button"
          className={`${ui.button} ${ui.secondary}`}
          onClick={onMyLearning}
          disabled={saving}
        >
          My Learning
        </button>
      )}

      {onReset && (
        <div style={{ position: "fixed", bottom: 12, right: 16 }}>
          <ResetTablet onReset={onReset} />
        </div>
      )}
      {retry && <RetryPanel onRetry={retry} saving={saving} />}
    </Frame>
  );
};

export default Waiting;
